<template>
  <div class="goods-content-container">
    <div class="goods-body-container">
      <div class="accound-list">
        <div class="account-tittle-bac">
          <div class="even-more" style="display: flex" v-show="allAccountInfoData.length >= 1">
            <el-radio-group v-model="radioLabel" size="mini" @change="runkChange">
              <el-radio-button v-for="item in allAccountInfoData.slice(
            0,
            allAccountInfoDataIndex
          )" :key="item.id" :label="item.id">{{ item.name }}</el-radio-button>
            </el-radio-group>
          </div>
          <div class="even-more" v-show="allAccountInfoData.length == 0"
            style="display: flex; width: 100%; justify-content: center">
            {{ aaa }}
          </div>
          <div class="few-list" v-show="allAccountInfoData.length > 7">
            <div style="display: none" ref="upRef">
              <el-button type="primary" @click="upClick">收起 <i class="el-icon-arrow-up"></i></el-button>
            </div>
            <div style="display: flex" ref="downRef">
              <el-button type="primary" @click="downClick">更多<i class="el-icon-arrow-down"></i></el-button>
            </div>
          </div>
        </div>
      </div>
      <div v-show="accoundFalse">
        <div class="goods-body-box">
          <div class="goods-container-row">
            <div class="goods-charts-box">
              <div class="goods-box-tittle" style="justify-content: space-between">
                <span>帐户概况 </span>
              </div>
              <div class="aErr-overview" v-if="vipErrShow">
                {{ accountTitel }}
              </div>
              <div class="aErr-overview" v-show="aErrShow">暂无数据</div>
              <div class="account-overview" v-show="vipShow">
                <div class="account-overview-td">
                  <span>帐户资产</span>
                  <div>
                    {{ this.formatNum(this.assetsArr.asset) }}
                  </div>
                </div>
                <div class="account-overview-td">
                  <span>收益</span>
                  <div>{{ this.formatNum(this.assetsArr.earning) }}</div>
                </div>
                <div class="account-overview-td">
                  <span>收益率</span>
                  <div :style="{
            color: this.setNumberColor(this.assetsArr.earningScale),
          }">
                    {{
                    this.assetsArr.earningScale == 0
                    ? 0
                    : this.formatNum(this.assetsArr.earningScale) + '%'
                    }}
                  </div>
                </div>
                <div class="account-overview-td">
                  <span>最大回撤</span>
                  <div class="price" :style="{
              color: setNumberColor(this.assetsArr.maxR),
            }">
                    {{
                    this.assetsArr.maxR == 0
                    ? 0
                    : this.formatNum(this.assetsArr.maxR) + '%'
                    }}
                  </div>
                </div>
                <div class="account-overview-td maximum-drawdown">
                  <span>交易天数</span>
                  <div>
                    {{ this.formatNum(this.assetsArr.days) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="goods-body-box">
          <div class="goods-container-row">
            <!-- <div class="goods-charts-box">
              <div class="goods-box-tittle">
                <span>每日盈亏 </span>
                <div class="company">(USD)</div>
              </div>

              <div class="goods-total-user-assets">
                <div class="goods-assets-header">
                  <div class="goods-assets-tittle">
                    <div class="price">{{ this.formatNum(profitLoss) }}</div>
                    <div class="data">
                      数据更新时间:<span>{{ profitLossDate }}</span>
                    </div>
                  </div>
                  <div class="goods-earnings-select">
                    <el-select
                      style="width: 80px"
                      v-model="timeValue"
                      @change="timeChange($event)"
                      placeholder="时间"
                      :popper-append-to-body="false"
                    >
                      <el-option
                        v-for="item in dateOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="goods-assets-body">
                  <div class="goods-charts">
                    <chart class="" :option="profitAndLossOption" />
                  </div>
                </div>
              </div>
            </div> -->
            <div class="goods-charts-box">
              <div class="goods-box-tittle" style="justify-content: space-between">
                <span>资产分布 </span>
              </div>
              <div class="aErr-overview" v-if="assetErrShow">
                {{ assetTitel }}
              </div>
              <div class="goods-total-user-assets asset-distribution" v-if="assetShow">
                <div class="goods-assets-body">
                  <div class="goods-charts">
                    <chart class="chart" :option="assetsOption" :style="{ width: '100%' }" />
                  </div>
                </div>
              </div>

              <!-- <div class="more-than-empty">
                <div class="assets-body" v-show="isShow">
                  <chart
                    class="chart"
                    :option="assetsOption"
                    :style="{ width: '100%' }"
                  />
                </div>
                <div class="assets-body-list" v-show="!isShow">
                  <el-table
                    :data="this.showData"
                    height="518"
                    border
                    :row-class-name="tableRowClassName"
                    class="current-assets"
                    style="width: 100%"
                    :header-cell-style="{
                      background: 'rgba(66,67,75,1)',
                      color: 'rgba(237, 189, 136, 1)',
                    }"
                  >
                    <el-table-column
                      type="index"
                      width=""
                      align="center"
                      v-if="false"
                    ></el-table-column>
                    <el-table-column
                      prop="symbol"
                      label="标的名称"
                      align="center"
                    >
                      <template slot-scope="scope">{{
                        scope.row.name
                      }}</template>
</el-table-column>
<el-table-column prop="symbol" label="总价值(USD)" align="center">
  <template slot-scope="scope">
                        {{ scope.row.value.toFixed(2) }}</template>
</el-table-column>
<el-table-column prop="symbol" label="百分比" align="center">
  <template slot-scope="scope">{{
                        scope.row.percentage + '%'
                      }}</template>
</el-table-column>
</el-table>
</div>
</div> -->
            </div>
          </div>
        </div>
        <div class="goods-body-box">
          <div class="goods-container-row">
            <div class="goods-charts-box">
              <div class="goods-box-tittle">
                <span>收益展示 </span>
              </div>
              <div class="aErr-overview" v-if="earningsErrShow">
                {{ earningsTitel }}
              </div>
              <div class="goods-total-user-assets" v-if="earningstShow">
                <div class="goods-assets-header">
                  <div class="earnings-select">
                    <el-select class="earningBtn" v-model="earningValue" style="width: 96px" placeholder="收益"
                      :popper-append-to-body="false" @change="earningChange">
                      <el-option v-for="item in earningOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                    <el-select style="width: 96px" v-model="dateRadio" @change="earningTimeChange" placeholder="时间"
                      :popper-append-to-body="false">
                      <el-option v-for="item in earningDateOptions" :key="item.value" :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="goods-assets-body">
                  <div class="goods-charts">
                    <chart class="goods-chart" :option="earningOption" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="goods-body-box">
          <div class="goods-container-row">
            <div class="goods-charts-box">
              <div class="goods-box-tittle">
                <span>操作记录 </span>
              </div>
              <div class="aErr-overview" v-if="historyErrShow">
                {{ historyTitel }}
              </div>
              <div class="goods-total-user-assets" v-if="historyShow">
                <div class="goods-assets-header history-header">
                  <div class="earnings-select">
                    <el-input class="searchSelect" placeholder="币种搜索" v-model="currency" clearable size="small">
                    </el-input>
                    <el-button @click="currencyChange">搜索</el-button>
                    <!-- <el-input
                      class="searchSelect"
                      v-model="search"
                      size="mini"
                      placeholder="币种搜索"
                    /> -->
                  </div>
                </div>
                <div class="goods-assets-body">
                  <el-table :data="historyInformationData" border :row-class-name="tableRowClassName"
                    class="position-history" style="width: 100%" :header-cell-style="{
            background: 'rgba(66,67,75,1)',
            color: 'rgba(237, 189, 136, 1)',
          }">
                    <el-table-column label="标的" prop="symbol" align="center">
                    </el-table-column>
                    <el-table-column label="方向" prop="side" align="center">
                      <template slot-scope="scope">
                        <div :style="{
            color:
              scope.row.side == 'Buy'
                ? 'rgba(0, 174, 147, 1)'
                : 'rgba(247, 82, 95, 1)',
          }">
                          {{ scope.row.side ? scope.row.side : '-' }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="成交价格" prop="execPrice" align="center">
                      <template slot-scope="scope">
                        <div>
                          {{
                          scope.row.execPrice
                          ? formatNum(scope.row.execPrice)
                          : '-'
                          }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="成交数量" prop="execQty" align="center">
                      <template slot-scope="scope">
                        <div>
                          {{
                          scope.row.execQty
                          ? formatNum(scope.row.execQty)
                          : '-'
                          }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="成交额" prop="execValue" align="center">
                      <template slot-scope="scope">
                        <div>
                          {{
                          scope.row.execValue
                          ? formatNum(scope.row.execValue)
                          : '-'
                          }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="成交时间" prop="execTime" align="center">
                    </el-table-column>
                  </el-table>
                  <div class="pagingBox">
                    <Paging :pageNum="pageParams.pageNum" :total="total" :pageSize="pageParams.pageSize"
                      @sizeChange="sizeChange" @currentChange="currentChange" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="goods-body-box">
          <div class="goods-container-row">
            <div class="goods-charts-box">
              <div class="goods-box-tittle">
                <span>总资产估值 </span>
                <div class="company">(USD)</div>
              </div>

              <div class="goods-total-user-assets">
                <div class="goods-assets-header">
                  <div class="goods-assets-tittle">
                    <div class="total-price">
                      {{ valuationAsset }}
                    </div>
                    <div class="data">
                      数据更新时间: <span>{{ valuationDate }}</span>
                    </div>
                  </div>
                  <div class="goods-assets-bnt">
                    <el-radio-group
                      @change="valuationCange"
                      class="earningChange"
                      v-model="valuationRadio"
                      size="mini"
                    >
                      <el-radio-button label="week">近7天</el-radio-button>
                      <el-radio-button label="halfYear">近半年</el-radio-button>
                      <el-radio-button label="year">近一年</el-radio-button>
                      <el-radio-button label="">全部</el-radio-button>
                    </el-radio-group>
                  </div>
                </div>
                <div class="goods-assets-body">
                  <div class="goods-charts">
                    <chart class="goods-chart" :option="TotalAarningOption" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="goods-body-box">
          <div class="goods-container-row">
            <div class="goods-charts-box">
              <div class="goods-box-tittle">
                <span>现货盈亏分析 </span>
                <div class="data">
                  数据更新时间: <span>{{ accountText }}</span>
                </div>
              </div>

              <div class="analysis-total-user-assets">
                <div class="analysis-box">
                  <div
                    class="analysis-btn"
                    style="border-right: 1px solid rgba(255, 255, 255, 0.1)"
                  >
                    <span>总资产 (USD)</span>
                    <div class="total-price">
                      {{ this.formatNum(profitLosArr.totaAssetsUsd) }}
                    </div>
                  </div>
                  <div
                    class="analysis-btn"
                    style="border-right: 1px solid rgba(255, 255, 255, 0.1)"
                  >
                    <span>今日盈亏 (USD)</span>
                    <div
                      class="total-price"
                      :style="{
                        color:
                          profitLosArr.todayProfitLoss > 0
                            ? '#00AE93'
                            : profitLosArr.todayProfitLoss == 0
                            ? '#d1d4dc'
                            : '#F7525F',
                      }"
                    >
                      {{
                        profitLosArr.todayProfitLoss > 0
                          ? '+' + this.formatNum(profitLosArr.todayProfitLoss)
                          : this.formatNum(profitLosArr.todayProfitLoss)
                      }}
                    </div>
                    <div
                      class="up-down"
                      :style="{
                        color:
                          profitLosArr.todayScale >= 0
                            ? 'rgba(0, 174, 147, 1)'
                            : 'rgba(247, 82, 95, 1)',
                      }"
                    >
                      <div style="line-height: 20px">
                        <img
                          :src="
                            profitLosArr.todayScale > 0
                              ? url1
                              : profitLosArr.todayScale < 0
                              ? url2
                              : url3
                          "
                          alt=""
                        />
                      </div>
                      {{
                        profitLosArr.todayScale == 0
                          ? ''
                          : profitLosArr.todayScale + '%'
                      }}
                    </div>
                  </div>
                  <div class="analysis-btn">
                    <span>近7日累计盈亏 (USD)</span>
                    <div
                      class="total-price"
                      :style="{
                        color:
                          profitLosArr.sevenProfitLoss > 0
                            ? '#00AE93'
                            : profitLosArr.sevenProfitLoss == 0
                            ? '#d1d4dc'
                            : '#F7525F',
                      }"
                    >
                      {{
                        profitLosArr.sevenProfitLoss > 0
                          ? '+' + this.formatNum(profitLosArr.sevenProfitLoss)
                          : this.formatNum(profitLosArr.sevenProfitLoss)
                      }}
                    </div>
                    <div
                      class="up-down"
                      :style="{
                        color:
                          profitLosArr.sevenScale < 0
                            ? 'rgba(247, 82, 95, 1)'
                            : 'rgba(0, 174, 147, 1)',
                      }"
                    >
                      <div style="line-height: 20px">
                        <img
                          :src="
                            profitLosArr.sevenScale > 0
                              ? url1
                              : profitLosArr.sevenScale < 0
                              ? url2
                              : url3
                          "
                          alt=""
                        />
                      </div>
                      {{
                        profitLosArr.sevenScale == 0
                          ? ''
                          : profitLosArr.sevenScale + '%'
                      }}
                    </div>
                  </div>
                </div>
                <div class="analysis-assets-btn">
                  <div class="dete-btn">
                    <el-radio-group
                      class="dete-radio"
                      @change="dateChange"
                      v-model="dateRadio"
                      size="mini"
                    >
                      <el-radio-button
                        v-for="item in dateTypeData"
                        :key="item.id"
                        :label="item.id"
                        >{{ item.name }}</el-radio-button
                      >
                    </el-radio-group>
                  </div>
                </div>
                <div class="analysis-assets-header">
                  <div class="analysi-assets-tittle">
                    <div class="tittle">累计收益率</div>
                    <div
                      class="total-price"
                      :style="{
                        color:
                          Yielde < 0
                            ? 'rgba(247, 82, 95, 1)'
                            : 'rgba(0, 174, 147, 1)',
                      }"
                    >
                      {{ Yielde }}%
                    </div>
                  </div>
                </div>
                <div class="analysis-assets-body">
                  <div class="goods-charts">
                    <chart class="goods-chart" :option="yieldOption" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
  import Chart from '../../echarts/chart.vue';
  import Paging from '../paging/index.vue'; //引入封装的分页器文件
  import {
    getSpotAarnings,
    getSpotDayinfo,
    getSpotBaseinfo,
    getSpotAssets,
    getSpotScale,
    getSpotHistory,
  } from '../../api/spot';
  export default {
    components: { Chart, Paging },
    data() {
      return {
        url1: require('../../assets/img/rtaLogo/up.svg'),
        url2: require('../../assets/img/rtaLogo/down.svg'),
        url3: '',
        assetC: '',
        earningDate: '',
        earningOption: {},
        dateRadio: 'all',
        earningValue: 'earning',
        valuationRadio: '',
        valuationAsset: '',
        valuationDate: '',
        profitAndLossOption: {},
        profitLoss: '',
        profitLossDate: '',
        timeValue: '',
        earningDateOptions: [
          {
            value: 'month',
            label: '1月',
          },
          {
            value: 'halfYear',
            label: '半年',
          },
          {
            value: 'year',
            label: '一年',
          },
          {
            value: '',
            label: '全部',
          },
        ],
        earningOptions: [
          {
            value: 'assets',
            label: '资产',
          },
          {
            value: 'earning',
            label: '收益',
          },
          {
            value: 'scale',
            label: '收益率',
          },
        ],
        dateOptions: [
          {
            value: 'one',
            label: '一天',
          },
          {
            value: 'seven',
            label: '七天',
          },
          {
            value: 'thirty',
            label: '30天',
          },
          {
            value: '',
            label: '全部',
          },
        ],
        assetsArr: {
          asset: '',
          earning: '',
          earningScale: '',
          days: '',
          maxR: '',
        },
        assetsOption: {},
        TotalAarningOption: {},
        profitLosArr: {
          profitLDate: '1111111',
          totaAssets: '111111111',
          totaAssetsUsd: '1111',
          todayProfitLoss: '11111',
          sevenProfitLoss: '111111',
          todayScale: '111111111111',
          sevenScale: '11111111111',
        },
        yieldOption: {},
        Yielde: '',
        rateXData: '',
        rateYData: '',
        dateRadio: '',
        dateTypeData: [
          {
            id: 'seven',
            name: '近7天',
          },
          {
            id: 'thirty',
            name: '近30天',
          },

          {
            id: 'ninety',
            name: '近90天',
          },
          {
            id: '',
            name: '全部',
          },
        ],
        allAccountInfoData: [
          {
            id: 0,
            name: '',
          },
        ],
        accountRadio: '',
        radioLabel: '',
        allAccountInfoDataIndex: 0,
        showData: [],
        accountText: '',
        sliceFrist: [],
        oeherArr: [],
        ultimatelyArr: [],
        ifDisplay: true,
        isShow: true,
        accoundFalse: true,
        currencyImage: '',
        historyInformationData: [],
        search: '',
        total: 0, //数据总条数
        pageParams: {
          pageNum: 1, //默认第一页
          pageSize: 10, //一页展示10条
        },
        vipShow: false,
        vipErrShow: false,
        accountTitel: '',
        assetShow: false,
        assetErrShow: false,
        assetTitel: '',
        earningstShow: false,
        earningsErrShow: false,
        earningsTitel: '',
        historyShow: false,
        historyErrShow: false,
        historyTitel: '',
        currency: '',
        radio: '',
        aErrShow: false,
        aaa: '未绑定交易所',
      };
    },
    async created() {
      await this.load_data();
    },
    mounted() {
      // this.load_data();
    },
    methods: {
      currencyChange() {
        // this.currency = value;
        this.historyInformationData = [];
        this.findHistoryById();
      },
      //奇偶行背景色不同
      tableRowClassName({ rowIndex }) {
        if ((rowIndex + 1) % 2 === 0) {
          return 'oddRow';
        }

        return 'evenRow';
      },
      //页面刚加载的时候，开始判断，如果有登录就显示账户全部数据
      async load_data() {
        this.allAccountInfoData = this.$store.state.apiNameArr;
        if (this.allAccountInfoData.length == 0) {
          this.accountRadio = '';
          this.accoundFalse = false;
        } else {
          const uuid = this.$route.query.targetUUID;
          this.radio = uuid ? '' : this.allAccountInfoData[0].id;
          this.radioLabel = this.allAccountInfoData[0].id;
          // this.accountRadio = this.allAccountInfoData[0].id;
          const userInfo = JSON.parse(localStorage.getItem('userInfo'));
          const currentInfo = this.$route.query.userName
          let infoIndex = 7

          if (currentInfo) {
            infoIndex = (userInfo.nickname === currentInfo ? userInfo.nickname : currentInfo).length
          } else {
            infoIndex = userInfo.nickname.lenght
          }
          //账户显示长度判断
          this.allAccountInfoDataIndex =
            infoIndex > 7
              ? 7
              : infoIndex;
          await this.findAccumulatedIncomeById();
          //await this.findDailyProfitAndLossById();
          await this.findSpotBaseinfoById('create');
          //await this.findTotalAssets();
          //await this.findCumulativeRateById();
          await this.findHistoryById();
        }
      },
      //账户筛选
      runkChange(value) {
        this.radio = value;
        this.showData = [];
        this.earningValue = 'earning';
        this.dateRadio = '';
        this.findAccumulatedIncomeById();
        this.findSpotBaseinfoById();
        this.findHistoryById();
      },
      //获取资产分布和帐户概况全部数据
      async findSpotBaseinfoById(staus = '') {
        let params = {
          targetUUID: this.$route.query.targetUUID,
          accountId: this.radio,
        };
        const { data: res } = await getSpotBaseinfo(params);
        if (res.code == 0) {
          var bb = JSON.stringify(res.data) == '{}';
          if (bb == false) {
            this.aErrShow = false;
            this.vipShow = true;
            this.vipErrShow = false;
            this.assetShow = true;
            this.assetErrShow = false;
            this.allAccountInfoData = res.data.account.allAccountInfo;
            if (typeof this.$route.query.targetUUID == 'string') {
              if (staus == 'create')
                this.radioLabel = res.data.account.allAccountInfo[0].id;
            }
            let accounts = res.data;
            let newArr = [...accounts.soptData].sort((a, b) => b.value - a.value);
            let arr1 = [];
            let arr2 = [];
            let iconArry = [];
            newArr.forEach((item) => {
              let symbol = item.symbol;
              if (['BTC', 'ETH', 'USDT'].includes(symbol)) {
                if (symbol === 'BTC') {
                  arr1[0] = item;
                } else if (symbol === 'ETH') {
                  arr1[1] = item;
                } else {
                  arr1[2] = item;
                }
              } else {
                arr2.push(item);
              }
            });
            arr1.push(...arr2);

            arr1.forEach((item) => {
              let valueArr = arr1.map((v) => parseFloat(v.value));
              var sum = 0;
              var i = 0;
              valueArr.forEach((item) => {
                sum += item;
              });
              const accountObj = {
                value: parseFloat(item.value),
                name: item.symbol,
                percentage: ((parseFloat(item.value) / sum) * 100).toFixed(2),
                currencyImage:
                  '../../assets/img/currencyIcon/' + item.symbol + '.png',
                label: {
                  rich: {
                    img1: {
                      backgroundColor: {
                        image: require('../../assets/img/currencyIcon/' +
                          item.symbol +
                          '.png'),
                      },
                      height: 32,
                    },
                  },
                },
              };
              this.showData.push(accountObj);

              if (this.showData.length > 7) {
                this.sliceFrist = this.showData.slice(0, 7);
                this.oeherArr = this.showData.slice(5, this.showData.length);
                let totalScore = this.oeherArr.reduce((pre, cur) => {
                  return pre + parseFloat(cur.value);
                }, 0);
                var other = {
                  name: '其他',
                  value: totalScore.toFixed(2),
                  percentage: ((totalScore / sum) * 100).toFixed(2),
                };
                this.sliceFrist.push(other);
              } else {
                this.sliceFrist = this.showData;
              }
            });
            this.assetsArr.asset = accounts.asset.toFixed(2);
            this.assetsArr.earning = accounts.earning.toFixed(2);
            this.assetsArr.earningScale = accounts.earningScale.toFixed(2);
            this.assetsArr.days = accounts.days;
            this.assetsArr.maxR = accounts.maxR.toFixed(2);
            this.getAssetsData();
          } else {
            this.aErrShow = true;
            this.vipShow = false;
            this.sliceFrist = [];

            this.getAssetsData();
            this.profitLosArr.totaAssetsUsd = '';
            this.profitLosArr.todayProfitLoss = '';
            this.profitLosArr.todayScale = '';

            this.profitLosArr.sevenProfitLoss = '';
            this.profitLosArr.sevenScale = '';
          }
        } else if (res.code == 10006) {
          this.allAccountInfoData = [];
          this.aaa = '用户等级不足，不可以访问该信息！';
        } else {
          this.allAccountInfoData = [];

          this.accountTitel = res.msg;
          this.vipShow = false;
          this.vipErrShow = true;
          this.assetShow = false;
          this.assetErrShow = true;
          this.assetTitel = res.msg;
          this.accountText = '';
          //(accounts);
          this.profitLosArr.totaAssetsUsd = '';
          this.profitLosArr.todayProfitLoss = '';
          this.profitLosArr.todayScale = '';

          this.profitLosArr.sevenProfitLoss = '';
          this.profitLosArr.sevenScale = '';
        }
      },
      //资产分布图表数据展示
      getAssetsData() {
        let showData = this.sliceFrist;
        let valueArr = showData.map((v) => parseFloat(v.value));
        var sum = 0;
        var i = 0;
        valueArr.forEach((item) => {
          sum += item;
        });
        if (showData.length > 0) {
          this.assetsOption = {
            tooltip: {
              trigger: 'item',
              formatter: (a) => {
                var str = '';
                var aaa = this.kmb(a.value);
                return str.concat(
                  `<div style="display:flex; width: 100%;font-size: 16px">
                  <div style="flex:1; padding: 0 8px;">${a.name}</div>
                  <div style="flex:1; padding: 0 8px;">
                    <div>${aaa}</div>
                    <div style="font-size: 12px;color: rgba(209, 212, 220, 0.6);">数量</div>
                  </div>
                  <div style="flex:1; padding: 0 8px;">
                  <div>${((a.value / sum) * 100).toFixed(2)}%</div>
                    <div style="font-size: 12px;color: rgba(209, 212, 220, 0.6);">百分比</div>
                  </div>
                </div>`
                );
              },
              backgroundColor: 'rgba(61, 63, 71, 1)',
              extraCssText: 'color:#D1D4DC;height:auto; width: auto;',
              borderColor: ' rgba(61, 63, 71, 0.5)',
              width: 1000,
              // borderColor: 'rgba(237, 189, 136, 1)',
            },
            visualMap: {
              //有下面两种写法
              show: false,
              splitNumber: 8,
              // borderColor: 'rgba(237, 189, 136, 1)',
              // color: ['#d94e5d', '#eac736', '#50a3ba'],     //此种写法是echart2的写法，不推荐使用，但是可以使用，能生效
              inRange: {
                //这种写法才是目前主流的写法
                color: [
                  'rgba(77, 78, 85, 1)',
                  'rgba(77, 78, 85, 1)',
                  'rgba(77, 78, 85, 1)',
                  'rgba(77, 78, 85, 1)',
                  'rgba(77, 78, 85, 1)',
                  'rgba(77, 78, 85, 1)',
                  'rgba(77, 78, 85, 1)',
                  'rgba(77, 78, 85, 1)',
                ],
                borderColor: 'red',
              },
            },
            series: [
              {
                type: 'treemap',
                center: ['50%', '50%'],
                left: '0%',
                top: '0%',
                right: '0%',
                width: '100%',
                roam: false,
                breadcrumb: { show: false },
                itemStyle: {
                  //  gapWidth: 1,
                  // borderWidth: 1,
                  // borderColor: 'rgba(159, 159, 159, 0.1)',
                  gapWidth: 6,
                  borderColorSaturation: 0.42,
                },
                emphasis: {
                  disabled: true,
                  itemStyle: {
                    shadowColor: 'red',
                  },
                },
                label: {
                  position: 'inside',
                  show: true,
                  align: 'center',
                  padding: [150, 0, 0, 0],
                  formatter: function (a) {
                    var str = '';
                    return str.concat(
                      '{img1|}' + '\n\n',
                      a.name +
                      ':  ' +
                      a.value +
                      '/' +
                      ((a.value / sum) * 100).toFixed(2) +
                      '%'
                    );
                  },
                  // //这里的重点在于设置百分比
                  position: 'inside',
                  color: 'rgba(209, 212, 220, 1)',
                  fontSize: 14,
                },
                height: '100%',
                data: showData,
                // data: [],
                visualMin: 0,
                childrenVisibleMin: 0,
              },
            ],

          };
        } else {
          this.assetsOption = {
            title: {
              text: '暂无数据',
              x: 'center',
              y: 'center',
              textStyle: {
                fontSize: 16,
                fontWeight: 'normal',
                color: 'rgba(209, 212, 220, 1)', //设置文字颜色
              },
            },
            tooltip: {
              show: false,
            },
            series: [
              {
                data: [],
                label: {
                  show: false,
                },
              },
            ],
          };
        }
      },
      upClick() {
        this.allAccountInfoDataIndex = 7;
        this.$refs.upRef.style.display = 'none';
        this.$refs.downRef.style.display = 'flex';
      },
      downClick() {
        this.allAccountInfoDataIndex = this.allAccountInfoData.length;
        this.$refs.upRef.style.display = 'flex';
        this.$refs.downRef.style.display = 'none';
      },
      //累计收益额收益类型筛选
      earningChange(value) {
        this.findAccumulatedIncomeById();
        this.earningValue = value;
      },
      //累计收益率时间类型筛选
      earningTimeChange(value) {
        this.findAccumulatedIncomeById();
        this.dateRadio = value;
      },
      //获取收益展示所有数据
      async findAccumulatedIncomeById() {
        let params = {
          targetUUID: this.$route.query.targetUUID,
          accountId: this.radio,
          queryType: this.earningValue,
          queryTime: this.dateRadio,
        };
        const { data: res } = await getSpotAarnings(params);
        let allData = res.data;
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.earningstShow = true;
            this.earningsErrShow = false;
            this.earningDate = allData[0].date;
            this.earningXData = allData.map((v) =>
              this.dateTypeFormat('YYYY-mm-dd HH:MM', new Date(v.date))
            );
            this.earningYData = allData.map((v) => v.queryData.toFixed(2));
          } else {
            this.assetC = '';
            this.earningXData = [];
            this.earningYData = [];
          }
        } else if (res.code == 10006) {
          this.accoundFalse = false;
          this.earningstShow = false;
          this.earningsErrShow = true;
          this.earningsTitel = res.msg;
          this.assetC = '';
          this.earningXData = 0;
          this.earningYData = 0;
        } else {
          this.assetC = '';
          this.earningDate = ' 暂无时间';
          this.earningXData = [];
          this.earningYData = [];
        }

        this.getdEarningsData();
      },
      // 收益展示图表数据展示
      getdEarningsData() {
        let queryType = this.earningValue;
        const xData = this.earningXData;
        const yData = this.earningYData;
        const nameData = ['资产', '收益', '总收益率'];
        if (xData.length == 0) {
          //暂无数据
          this.earningOption = {
            title: {
              text: '暂无数据',
              x: 'center',
              y: 'center',
              textStyle: {
                fontSize: 16,
                fontWeight: 'normal',
                color: 'rgba(209, 212, 220, 1)', //设置文字颜色
              },
            },
            xAxis: {
              data: [],
            },
            series: [
              {
                data: [],
              },
            ],
          };
        } else {
          this.earningOption = {
            title: {
              text: '',
            },
            color: 'rgba(0, 174, 147, 1)',
            tooltip: {
              trigger: 'axis',
              borderWidth: '0', //边框宽度设置1
              borderColor: 'none', //设置边框颜色
              formatter: (params, i) => {
                i = queryType;
                let result = `${params[0].name}<br>`;
                if (i == 'asset') {
                  params.forEach((item) => {
                    var aaa = this.kmb(item.value);
                    result += `资产 : <span style="color:rgba(0, 174, 147, 1);padding-left:5px;font-size:16px;">$${aaa}</br>`;
                  });
                  return result;
                }
                if (i == 'earning') {
                  params.forEach((item) => {
                    var aaa = this.kmb(item.value);
                    result += `收益 : <span style="color:rgba(0, 174, 147, 1);padding-left:5px;font-size:16px;">$${aaa}</br>`;
                  });
                  return result;
                } else if (i == 'scale') {
                  params.forEach((item) => {
                    if (item.value < 0) {
                      result += `收益率 : <span style="color:rgba(247, 82, 95, 1);padding-left:5px;font-size:16px;">${this.formatNum(
                        item.value
                      )}%</br>`;
                    } else {
                      result += `收益率 : <span style="color:rgba(0, 174, 147, 1);padding-left:5px;font-size:16px;">${this.formatNum(
                        item.value
                      )}%</br>`;
                    }
                  });
                  return result;
                }
              },
              padding: 20,
              textStyle: {
                color: 'rgba(209, 212, 220, 1)', //设置文字颜色
                fontSize: '16',
              },
              extraCssText: 'background:rgba(61, 63, 71, 1);',
            },
            grid: {
              top: '5%',
              left: '0%',
              right: '3%',
              bottom: '3%',
              containLabel: true,
            },

            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: xData,
              offset: 12,
              axisLabel: {
                textStyle: {
                  color: 'rgba(209, 212, 220, 1)',
                },
              },
            },
            yAxis: {
              type: 'value',
              splitLine: {
                lineStyle: {
                  // 使用深浅的间隔色
                  color: ['rgba(159, 159, 159, 0.1)'],
                },
              },
              axisLabel: {
                formatter: function (v, i) {
                  i = queryType;
                  if (i == 'scale') {
                    return v + '%';
                  } else {
                    if (v > 1000 && v <= 1000000) {
                      return v / 1000 + 'K';
                    } else if (v > 1000000 && v <= 1000000000) {
                      return v / 1000000 + 'M';
                    } else if (v > 1000000000) {
                      return v / 1000000000 + 'B';
                    } else {
                      return v;
                    }
                  }
                },
                textStyle: {
                  color: 'rgba(209, 212, 220, 1)',
                },
                margin: 20,
              },
            },
            // visualMap: [
            //   {
            //     type: 'piecewise',
            //     show: false,
            //     pieces: [
            //       {
            //         lt: -0.1, //数据<0.1配置
            //         color: 'rgba(255, 87, 87, 0.3)', //设置区域背景色
            //       },
            //       {
            //         gte: 0, //数据>=0配置
            //         color: 'rgba(0, 174, 147, 1)', //设置区域背景色
            //       },
            //     ],
            //     seriesIndex: 0,
            //   },
            // ],
            series: [
              {
                name: '资产',
                data: this.formatNum(yData),
                type: 'line',
                symbol: 'cricle',
                showSymbol: false,
                // lineStyle: {},
                // areaStyle: {}, //区域背景色
                lineStyle: {
                  color: 'rgba(0, 174, 147, 1)',
                },
                itemStyle: {
                  color: 'rgba(0, 174, 147, 1)',
                },

                areaStyle: {
                  normal: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0.1,
                          color: 'rgba(0, 174, 147, 0.2000)', // 0% 处的颜色
                        },
                        {
                          offset: 0.9,
                          color: 'rgba(0, 174, 147, 0)', // 100% 处的颜色
                        },
                      ],
                      globalCoord: false, // 缺省为 false
                    },
                  },
                },
              },
            ],
          };
        }
      },
      //获取操作记录所有数据
      async findHistoryById() {
        let params = {
          targetUUID: this.$route.query.targetUUID,
          accountId: this.radio,
          queryStr: this.currency,
          pageIndex: this.pageParams.pageNum,
          pageSize: this.pageParams.pageSize,
        };
        const { data: res } = await getSpotHistory(params);

        if (res.code == 0) {
          if (res.data.length > 0) {
            this.historyShow = true;
            this.historyErrShow = false;
            let historyInformation = res.data;
            this.total = res.total;

            historyInformation.forEach((item) => {
              const positionObj = {
                symbol: item.symbol,
                side: item.side,
                execPrice: this.Decimals(item.execPrice, 2),
                execQty: item.execQty,
                execValue: this.Decimals(item.execValue, 2),
                execTime: this.dateTypeFormat(
                  'YYYY-mm-dd HH:MM',
                  new Date(item.execTime)
                ),
              };
              this.historyInformationData.push(positionObj);
              //console.log(this.positionInformationData);
            });
          } else {
            this.historyShow = false;
            this.historyErrShow = true;
            this.historyTitel = '暂无数据';
          }
        } else if (res.code == 10006) {
          this.historyShow = false;
          this.historyErrShow = true;
          this.historyTitel = res.msg;
        }
      },
      // 点击页码及上一页下一页按钮操作
      currentChange(val) {
        this.pageParams.pageNum = val;
        this.historyInformationData = [];
        this.findHistoryById();
      },
      //每页展示几条按钮操作
      sizeChange(val) {
        this.pageParams.pageSize = val;
        this.historyInformationData = [];
        this.findHistoryById();
      },

      //获取每日盈亏所有数据
      async findDailyProfitAndLossById() {
        let params = {
          targetUUID: this.$route.query.targetUUID,
          accountId: this.radio,
          queryType: this.timeValue,
        };
        const { data: res } = await getSpotDayinfo(params);
        let dailData = res.data;
        if (res.code !== 0) {
          this.profitLoss = '';
          this.profitLossDate = '';
          this.dailXData = 0;
          this.dailYData = 0;
        } else {
          this.profitLoss = this.formatNum(dailData[0].earnings);
          this.profitLossDate = dailData[0].date;
          this.dailXData = dailData.map((v) => v.date);
          this.dailYData = dailData.map((v) => v.earnings);
        }

        this.getProfitAndLossData();
      },
      //每日盈亏图表数据展示
      getProfitAndLossData() {
        const xData = this.dailXData;
        const longPositionrYData = this.dailYData;
        if (longPositionrYData == 0) {
          //暂无数据
          this.profitAndLossOption = {
            title: {
              text: '暂无数据',
              x: 'center',
              y: 'center',
              textStyle: {
                fontSize: 16,
                fontWeight: 'normal',
                color: 'rgba(209, 212, 220, 1)', //设置文字颜色
              },
            },
          };
        } else {
          this.profitAndLossOption = {
            tooltip: {
              trigger: 'axis',
              backgroundColor: 'rgba(61, 63, 71, 1)',
              extraCssText: 'color:#D1D4DC;width:130px;height:auto',
              borderColor: ' rgba(61, 63, 71, 0.5)',
              formatter: (params) => {
                let result = `${params[0].name}<br>`;
                params.forEach((item) => {
                  if (item.value < 0) {
                    result += `${item.seriesName} : <span style="color:rgba(247, 82, 95, 1);font-size:16px;">${item.value}</br>`;
                  } else if (item.value > 1000 && item.value <= 1000000) {
                    result += `${item.seriesName
                      } : <span style="color:rgba(34, 171, 148, 1);font-size:16px;">${(
                        item.value / 1000
                      ).toFixed(4)}K</br>`;
                  } else if (item.value > 1000000 && item.value <= 1000000000) {
                    result += `${item.seriesName
                      } : <span style="color:rgba(34, 171, 148, 1);font-size:16px;">${(
                        item.value / 1000000
                      ).toFixed(4)}M</br>`;
                  } else if (item.value > 1000000000) {
                    result += `${item.seriesName
                      } : <span style="color:rgba(34, 171, 148, 1);font-size:16px;">${(
                        item.value / 1000000000
                      ).toFixed(4)}B</br>`;
                  } else {
                    result += `${item.seriesName} : <span style="color:rgba(34, 171, 148, 1);font-size:16px;">${item.value}</br>`;
                  }
                });
                return result;
              },
            },
            dataZoom: [
              {
                type: 'inside',
                realtime: true,
                start: 0,
                end: 100,
              },
              {
                show: true,
                realtime: true,
                height: 24, //这里可以设置dataZoom的尺寸
                bottom: 20,
                start: 0,
                end: 100,

                textStyle: {
                  color: '#fff', // 左右两边文字颜色
                },
              },
            ],

            calculable: true,
            grid: {
              top: '5%',
              left: '0%',
              right: '4%',
              containLabel: true,
            },
            xAxis: {
              type: 'category',
              data: xData.reverse(),
              offset: 12,
              axisLabel: {
                textStyle: {
                  color: 'rgba(209, 212, 220, 1)',
                },
              },
            },
            yAxis: {
              type: 'value',
              axisLabel: {
                formatter: function (v) {
                  // console.log(v);
                  if (v > 1000 && v <= 1000000) {
                    return v / 1000 + 'K';
                  } else if (v > 1000000 && v <= 1000000000) {
                    return v / 1000000 + 'M';
                  } else if (v > 1000000000) {
                    return v / 1000000000 + 'B';
                  } else {
                    return v;
                  }
                  // return v + 'K';
                },
                textStyle: {
                  color: 'rgba(209, 212, 220, 1)',
                },
                margin: 20,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(255, 255, 255, 0.1)',
                },
              },
            },
            series: [
              {
                name: '盈亏',
                data: longPositionrYData.reverse(),
                type: 'bar',
                showSymbol: false,
                itemStyle: {
                  color: function (params) {
                    let num = params.value;
                    if (num >= 0) {
                      return 'rgba(0, 174, 147, 1)';
                    } else {
                      return 'rgba(247, 82, 95, 1)';
                    }
                  },
                },
              },
            ],
          };
        }
      },
      //每日盈亏时间筛选
      timeChange(item) {
        this.timeValue = item;
      },

      // 每日盈亏饼图列表切换事件
      isExpand(event) {
        this.ifDisplay = !this.ifDisplay;
        this.isShow = !this.isShow;
      },

      //总资产估值时间筛选
      valuationCange(value) {
        this.valuationRadio = value;
        // this.findTotalAssets();
      },
      //获取总资产估值的所有数据
      async findTotalAssets() {
        let params = {
          targetUUID: this.$route.query.targetUUID,
          accountId: this.radio,
          queryType: this.valuationRadio,
        };
        const { data: res } = await getSpotAssets(params);

        let valuationData = res.data;
        if (res.code !== 0) {
          this.valuationAsset = '';
          this.valuationDate = '';
          this.valuationXData = 0;
          this.valuationYData = 0;
        } else {
          this.valuationAsset = valuationData[0].assets;
          this.valuationDate = valuationData[0].date;
          this.valuationXData = valuationData.map((v) => v.date);
          this.valuationYData = valuationData.map((v) => v.assets);
        }

        this.getdTotalAssetsData();
      },
      // 总资产估值图表数据展示
      getdTotalAssetsData() {
        if (this.valuationYData == 0) {
          //暂无数据
          this.TotalAarningOption = {
            title: {
              text: '暂无数据',
              x: 'center',
              y: 'center',
              textStyle: {
                fontSize: 16,
                fontWeight: 'normal',
                color: 'rgba(209, 212, 220, 1)', //设置文字颜色
              },
            },
          };
        } else {
          this.TotalAarningOption = {
            color: 'rgba(0, 174, 147, 1)',
            tooltip: {
              trigger: 'axis',
              borderWidth: '0', //边框宽度设置1
              borderColor: 'none', //设置边框颜色
              // formatter:
              //   '{b} <br/>{a}: <span style="color:#EDBD88;font-size:16px;">{c}',
              formatter: (params) => {
                let result = `${params[0].name}<br>`;
                params.forEach((item) => {
                  if (item.value > 1000 && item.value <= 1000000) {
                    result += `${item.seriesName
                      } : <span style="color:#EDBD88;font-size:16px;">${(
                        item.value / 1000
                      ).toFixed(4)}K</br>`;
                  } else if (item.value > 1000000 && item.value <= 1000000000) {
                    result += `${item.seriesName
                      } : <span style="color:#EDBD88;font-size:16px;">${(
                        item.value / 1000000
                      ).toFixed(4)}M</br>`;
                  } else if (item.value > 1000000000) {
                    result += `${item.seriesName
                      } : <span style="color:#EDBD88;font-size:16px;">${(
                        item.value / 1000000000
                      ).toFixed(4)}B</br>`;
                  } else {
                    result += `${item.seriesName} : <span style="color:#EDBD88;font-size:16px;">${item.value}</br>`;
                  }
                });
                return result;
              },
              padding: 20,
              textStyle: {
                fontSize: 16,
                color: 'rgba(209, 212, 220, 1)', //设置文字颜色
              },
              tooltip: {
                show: true,
              },
              extraCssText: 'background:rgba(61, 63, 71, 1);',
            },
            grid: {
              top: '4%',
              left: '0%',
              right: '3%',
              bottom: '3%',
              containLabel: true,
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              offset: 12,
              data: this.valuationXData.reverse(),
              axisLabel: {
                textStyle: {
                  color: 'rgba(209, 212, 220, 1)',
                },
              },
            },
            yAxis: {
              // type: 'log',
              type: 'value',
              splitLine: {
                lineStyle: {
                  color: ['rgba(159, 159, 159, 0.1)'],
                },
              },
              axisLabel: {
                formatter: function (v) {
                  // console.log(v);
                  if (v > 1000 && v <= 1000000) {
                    return v / 1000 + 'K';
                  } else if (v > 1000000 && v <= 1000000000) {
                    return v / 1000000 + 'M';
                  } else if (v > 1000000000) {
                    return v / 1000000000 + 'B';
                  } else {
                    return v;
                  }
                  // return v + 'K';
                },
                textStyle: {
                  color: 'rgba(209, 212, 220, 1)',
                },
                margin: 20,
              },
            },
            series: [
              {
                name: '金额',
                data: this.valuationYData.reverse(),
                type: 'line',
                Symbol: 'cricle',
                showSymbol: false,
                lineStyle: {
                  color: 'rgba(237, 189, 136, 1)',
                },
                itemStyle: {
                  normal: {
                    color: 'rgba(237, 189, 136, 1)',
                  },
                },
                areaStyle: {
                  normal: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0.1,
                          color: 'rgba(237,189,136,0.2000)', // 0% 处的颜色
                        },
                        {
                          offset: 0.9,
                          color: 'rgba(237,189,136,0)', // 100% 处的颜色
                        },
                      ],
                      globalCoord: false, // 缺省为 false
                    },
                  },
                },
              },
            ],
          };
        }
      },
      //获取累计收益率所有数据
      async findCumulativeRateById() {
        let params = {
          targetUUID: this.$route.query.targetUUID,
          accountId: this.radio,
          queryType: this.dateRadio,
        };
        const { data: res } = await getSpotScale(params);
        let rateData = res.data;
        if (res.code == 10006) {
          this.Yielde = '';
          this.rateXData = 0;
          this.rateYData = 0;
        } else {
          this.Yielde = this.formatNum(rateData[0].earningsScale);
          this.rateXData = rateData.map((v) => v.date);
          this.rateYData = rateData.map((v) => v.earningsScale);
        }

        this.getYieldData();
      },
      // 累计收益率图表数据展示
      getYieldData() {
        const xData = this.rateXData;
        const accountYield = this.rateYData;
        if (accountYield == 0) {
          //暂无数据
          this.yieldOption = {
            title: {
              text: '暂无数据',
              x: 'center',
              y: 'center',
              textStyle: {
                fontSize: 16,
                fontWeight: 'normal',
                color: 'rgba(209, 212, 220, 1)', //设置文字颜色
              },
            },
          };
        } else {
          this.yieldOption = {
            color: 'rgba(0, 174, 147, 1)',
            // legend: {
            //   itemHeight: 16,
            //   itemWidth: 16,
            //   itemGap: 40,
            //   icon: 'roundRect',
            //   data: ['BTC价格累计涨跌率', '现货帐户累计收益率'],
            //   textStyle: {
            //     fontSize: 14,
            //     color: 'rgba(209, 212, 220, 1)',
            //   },
            // },
            tooltip: {
              trigger: 'axis',
              borderWidth: '0', //边框宽度设置1
              borderColor: 'none', //设置边框颜色
              //formatter: '{b} <br/><br/>{a0}:{c0}%<br/>{a1}:{c1}%<br/>{a2}:{c2}%',
              formatter(params) {
                let str = ' ';
                str += `<div>${params[0].name}</div></br>`;
                for (let i = 0; i < params.length; i += 1) {
                  str += `${params[i].marker}  <span>${params[i].seriesName}</span> : <span>${params[i].data}%</br>`;
                }
                return str;
              },
              padding: 20,
              textStyle: {
                fontSize: 16,
                fontWeight: 'normal',
                color: 'rgba(209, 212, 220, 1)', //设置文字颜色
              },
              extraCssText: 'background:rgba(61, 63, 71, 1);',
            },
            grid: {
              top: '15%',
              left: '1%',
              right: '3%',
              bottom: '3%',
              containLabel: true,
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: xData.reverse(),
              offset: 12,
              axisLabel: {
                textStyle: {
                  color: 'rgba(209, 212, 220, 1)',
                },
              },
            },
            yAxis: {
              type: 'value',
              // min: 'dataMin',
              // max: 'dataMax',
              offset: 12,
              splitLine: {
                lineStyle: {
                  // 使用深浅的间隔色
                  color: ['rgba(159, 159, 159, 0.1)'],
                },
              },
              axisLabel: {
                formatter: '{value} %',
                textStyle: {
                  color: 'rgba(209, 212, 220, 1)',
                },
              },
            },
            series: [
              {
                name: '现货帐户累计收益率',
                data: accountYield.reverse(),
                type: 'line',
                showSymbol: false,
                lineStyle: {
                  color: 'rgba(0, 174, 147, 1)',
                },
                itemStyle: {
                  color: 'rgba(0, 174, 147, 1)',
                },
                areaStyle: {
                  normal: {
                    color: {
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0.1,
                          color: 'rgba(0, 174, 147, 0.2000)', // 0% 处的颜色
                        },
                        {
                          offset: 0.9,
                          color: 'rgba(0, 174, 147, 0)', // 100% 处的颜色
                        },
                      ],
                      globalCoord: false, // 缺省为 false
                    },
                  },
                },
              },
            ],
          };
        }
      },
      handleEdit(index, row) { },
      handleDelete(index, row) { },
    },
  };
</script>

<style lang="scss">
  .goods-content-container {
    .goods-body-container {
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      text-align: center;
      margin: 0 auto;

      // padding-bottom: 182px;
      .accound-list {
        margin: 48px 0 0 0;

        .account-tittle {
          font-size: 24px;
          font-family: MicrosoftYaHei;
          color: #d1d4dc;
          line-height: 31px;
          text-align: left;
        }

        .account-tittle-bac {
          // width: 100%;

          border-radius: 4px;
          flex-direction: column;
          display: flex;
          justify-content: space-between;

          .even-more {
            width: 900px;
            text-align: left;

            .el-radio-group {
              .el-radio-button {
                width: 120px;
                height: 40px;
                padding: 0 !important;

                margin: 0 4px 4px 0;

                .el-radio-button__inner {
                  border-radius: 2px;
                  margin: 0;
                  padding: 0;
                  width: 120px;
                  height: 40px;
                  line-height: 40px;
                  background: transparent;
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 400;
                  color: #d1d4dc;
                  border: 1px solid rgba(151, 151, 151, 0.5);
                }

                .el-radio-button__inner:focus {
                  background: rgba(237, 189, 136, 1) !important;
                  color: #33353e;
                  border: none;
                }

                .el-radio-button__inner:hover {
                  background: transparent;
                  color: #edbd88;
                  border: 1px solid #edbd88;
                  border-radius: 2px;
                }

                .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                  background: rgba(237, 189, 136, 1);
                  color: #33353e;
                }

                .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                  border-color: none;
                  -webkit-box-shadow: none;
                  box-shadow: none;
                }
              }
            }
          }

          .few-list {
            height: 40px;

            .el-button {
              margin: 0;
              padding: 0;
              width: 74px;
              height: 32px;
              border-radius: 4px;
              border: 1px solid rgba(209, 212, 220, 0.5);
              background: transparent;

              span {
                font-size: 14px;
                font-family: MicrosoftYaHei;
                color: rgba(209, 212, 220, 1);
              }
            }
          }
        }
      }

      .goods-body-box {
        display: flex;
        width: 100%;
        height: 100%;

        .goods-container-row {
          width: 100%;
          height: 100%;

          .goods-charts-box {
            text-align: left;
            margin-top: 32px;

            .goods-box-tittle {
              height: 31px;
              display: flex;

              span {
                font-size: 16px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
                line-height: 31px;
                cursor: pointer;
              }

              .data {
                margin-left: 8px;
                font-size: 13px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                color: rgba(209, 212, 220, 0.7);
                margin-top: 8px;

                span {
                  font-size: 13px;
                  font-family: Roboto-Regular, Roboto;
                  font-weight: 400;
                  color: rgba(209, 212, 220, 0.7);
                }
              }

              .company {
                margin-left: 8px;
                display: flex;
                align-items: flex-end;
                font-size: 16px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                color: #d1d4dc;
              }
            }

            .accountTitel {
              width: 100%;
              background: #41434b;
              border-radius: 4px;
              padding: 41px 0;
              margin-top: 16px;
              text-align: center;
            }

            .account-overview {
              width: 100%;
              background: rgba(65, 67, 75, 1);
              display: flex;
              border-radius: 0px 0px 4px 4px;
              margin-top: 16px;

              .account-overview-td {
                width: 100%;
                height: 100%;
                margin: 20px 0 30px 24px;
                border-right: 1px solid rgba(255, 255, 255, 0.1);

                span {
                  font-size: 13px;
                  font-family: MicrosoftYaHei;
                  color: #d1d4dc;
                }

                div {
                  margin-top: 4px;
                  font-size: 24px;
                  font-family: DIN-Medium, DIN;
                  font-weight: 500;
                  color: #d1d4dc;
                }
              }

              .maximum-drawdown {
                border-right: none !important;
              }
            }

            .aErr-overview {
              margin-top: 16px;
              // background: #41434b;
              width: 100%;
              border-radius: 4px;
              display: flex;
              justify-content: center;
            }

            .asset-distribution {
              height: 100% !important;
            }

            .goods-total-user-assets {
              color: #d1d4dc !important;
              margin-top: 16px;
              width: 100%;
              height: 100%;
              // background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;

              .analysis-box {
                width: 100%;
                height: 160px;
                display: flex;

                .analysis-btn {
                  margin: 37px 32px;
                  height: 88px;
                  width: 336px;

                  span {
                    font-size: 16px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc;
                  }

                  .up-down {
                    height: 20px;
                    font-size: 16px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #00ae93;
                    line-height: 20px !important;
                    display: flex;

                    img {
                      margin-top: 3px;
                    }
                  }

                  .total-price {
                    height: 44px;
                    font-size: 36px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #d1d4dc;
                    line-height: 44px;
                  }
                }
              }

              .goods-assets-header {
                padding: 24px 0 24px 32px;
                display: flex;
                justify-content: flex-end;

                .earnings-select {
                  // margin: 20px 32px 0 0;
                  display: flex;
                  justify-content: flex-end;

                  .earningBtn {
                    margin-right: 20px;
                  }

                  .el-input {

                    // margin-left: 20px;
                    .el-input__inner {
                      height: 32px !important;
                      background: transparent !important;
                      border: 1px solid rgba(209, 212, 220, 0.5);
                      border-radius: 4px !important;
                      color: #d1d4dc;
                    }

                    .el-input__inner.is-focus {
                      color: #d1d4dc;
                    }

                    .el-select__caret {
                      line-height: 32px;
                    }
                  }

                  .searchSelect {
                    width: 120px;
                    height: 32px;
                    border-radius: 4px;
                    margin-right: 8px;
                    line-height: 32px;

                    .el-input__inner {
                      height: 32px !important;
                      background: transparent !important;
                      border: 1px solid rgba(209, 212, 220, 0.5);
                      border-radius: 4px !important;
                      color: #d1d4dc;
                    }
                  }

                  .el-button {
                    margin: 0;
                    padding: 0;
                    width: 60px;
                    height: 32px;
                    border: none;
                    background: #edbd88;

                    span {
                      font-size: 14px;
                      font-family: MicrosoftYaHei;
                      color: #33353e;
                    }
                  }
                }

                .goods-assets-tittle {
                  .total-price {
                    height: 44px;
                    font-size: 36px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #edbd88;
                    line-height: 44px;
                  }

                  .price {
                    height: 44px;
                    font-size: 36px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #00ae93;
                    line-height: 44px;
                  }

                  .data {
                    font-size: 13px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: rgba(209, 212, 220, 0.7);
                    margin-top: 8px;

                    span {
                      font-size: 13px;
                      font-family: Roboto-Regular, Roboto;
                      font-weight: 400;
                      color: rgba(209, 212, 220, 0.7);
                    }
                  }
                }

                .goods-assets-bnt {
                  .earningChange {
                    .el-radio-button {
                      width: 69px;
                      height: 32px;
                      border-radius: 16px;
                      padding: 0 !important;
                      margin: 0 !important;

                      .el-radio-button__inner {
                        width: 69px;
                        height: 32px;
                        background: transparent;
                        font-size: 13px;
                        font-family: MicrosoftYaHei;
                        color: #d1d4dc;
                        line-height: 17px;
                        border: none;
                      }

                      .el-radio-button__inner:focus {
                        background: #33353e !important;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        background: #33353e;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        border-color: none;
                        -webkit-box-shadow: none;
                        box-shadow: none;
                      }
                    }
                  }
                }
              }

              .history-header {
                background: rgba(102, 102, 102, 0.1);
                border-radius: 4px 4px 0px 0px;
                justify-content: flex-end;

                padding: 16px 16px;
                margin-bottom: 8px;
              }

              .goods-assets-body {
                .goods-charts {

                  // padding: 0 32px;
                  .chart {
                    height: 432px;
                  }
                }

                .position-history {
                  margin-bottom: 32px;

                  .el-table__header-wrapper {
                    display: block !important;

                    .el-table__header {
                      .has-gutter {
                        tr {
                          height: 48px !important;

                          .el-table__cell {
                            padding: 0 !important;

                            .cell {
                              height: 48px !important;
                              line-height: 48px !important;
                            }
                          }

                          .gutter {
                            background: rgba(102, 102, 102, 0.1) !important;
                            border-bottom: none;
                          }
                        }
                      }
                    }
                  }

                  // .is-scrolling-left {
                  //   display: none !important;
                  // }
                  .el-table__body-wrapper {

                    //display: none !important;
                    //height: 336px !important;
                    // display: none !important;
                    .el-table__body tr:hover>td {
                      background: rgba(237, 189, 136, 1) !important;

                      .cell {
                        color: #33353e !important;
                        font-size: 14px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;

                        .achieved {
                          color: #33353e !important;
                        }

                        img {
                          //filter: drop-shadow(0px 150px 0px #33353E);
                          transform: translateX(-100px);
                          filter: drop-shadow(#33353e 100px 0);
                        }
                      }
                    }

                    .el-table__body {
                      tr {
                        height: 48px !important;

                        th {
                          .cell {
                            .caret-wrapper {
                              .sort-caret {
                                border-top-color: rgba(237,
                                    189,
                                    136,
                                    1) !important;
                              }
                            }
                          }
                        }

                        td {
                          .cell {
                            line-height: 23px !important;

                            img {
                              overflow: hidden;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            .analysis-total-user-assets {
              color: #d1d4dc !important;
              margin-top: 20px;
              width: 100%;
              height: 771px;
              background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;

              .analysis-box {
                width: 100%;
                height: 94px;
                display: flex;
                padding: 37px 0 32px 0;

                .analysis-btn {
                  height: 88px;
                  width: 368px;
                  margin-left: 32px;

                  span {
                    font-size: 16px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc;
                  }

                  .up-down {
                    height: 20px;
                    font-size: 16px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #00ae93;
                    line-height: 20px !important;
                    display: flex;

                    img {
                      margin-top: 3px;
                    }
                  }

                  .total-price {
                    margin-bottom: 7px;
                    height: 44px;
                    font-size: 36px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #d1d4dc;
                    line-height: 44px;
                  }

                  .usdData {
                    font-size: 16px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: #d1d4dc;
                  }
                }
              }

              .analysis-assets-btn {
                background: rgba(66, 68, 77, 1);
                width: 100%;
                height: 65px;

                .dete-btn {
                  width: 1136px;
                  height: 64px;
                  margin: 0 32px;
                  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

                  // height: 32px;
                  .dete-radio {
                    display: flex;

                    .el-radio-button {
                      text-align: center;
                      width: 88px;
                      height: 64px;
                      line-height: 64px;
                      padding: 0 0;
                      border-radius: 0px !important;

                      .el-radio-button__inner {
                        width: 88px;
                        height: 64px;
                        line-height: 64px;
                        background: transparent;
                        border: none;
                        padding: 0 !important;
                        font-size: 16px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                        color: #d1d4dc;
                      }

                      .el-radio-button__inner:focus {
                        border-bottom: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        border-radius: 0px !important;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        border-bottom: 4px solid #edbd88;
                        -webkit-box-shadow: none;
                        box-shadow: none;
                      }
                    }
                  }
                }
              }

              .analysis-assets-header {
                padding: 32px 32px 0;
                display: flex;
                justify-content: space-between;
                background: rgba(66, 68, 77, 1);

                .analysi-assets-tittle {
                  .tittle {
                    height: 24px;
                    font-size: 18px;
                    font-family: MicrosoftYaHei;
                    color: #d1d4dc;
                    line-height: 24px;
                    margin-bottom: 8px;
                  }

                  .total-price {
                    height: 44px;
                    font-size: 36px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #edbd88;
                    line-height: 44px;
                  }

                  .price {
                    height: 44px;
                    font-size: 36px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #00ae93;
                    line-height: 44px;
                  }

                  .data {
                    font-size: 13px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: rgba(209, 212, 220, 0.7);
                    margin-top: 8px;

                    span {
                      font-size: 13px;
                      font-family: Roboto-Regular, Roboto;
                      font-weight: 400;
                      color: rgba(209, 212, 220, 0.7);
                    }
                  }
                }
              }

              .analysis-assets-body {
                padding-bottom: 35px;
                background: rgba(66, 68, 77, 1);
                border-radius: 0 0 8px 8px;

                .goods-charts {
                  padding: 0 32px;

                  .goods-chart {}
                }
              }
            }
          }
        }

        .goods-charts-container {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;

          .goods-charts-box {
            text-align: left;
            margin-top: 32px;
            width: 590px;
            height: 100%;

            .goods-box-tittle {
              width: 100%;
              height: 31px;
              display: flex;

              span {
                font-size: 24px;
                font-family: MicrosoftYaHei;
                color: #d1d4dc;
                line-height: 31px;
                cursor: pointer;
              }

              .switchover-btn {
                .el-button {
                  padding: 0;
                  margin: 11px 0 0 0;
                }
              }

              .company {
                margin-left: 8px;
                display: flex;
                align-items: flex-end;
                font-size: 16px;
                font-family: Roboto-Regular, Roboto;
                font-weight: 400;
                color: #d1d4dc;
              }
            }

            .goods-total-user-assets {
              color: #d1d4dc !important;
              margin-top: 20px;
              width: 100%;
              height: 518px !important;
              background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;

              .goods-assets-header {
                padding: 24px 32px;
                display: flex;
                justify-content: flex-end;

                .goods-assets-tittle {
                  .price {
                    height: 44px;
                    font-size: 36px;
                    font-family: DIN-Medium, DIN;
                    font-weight: 500;
                    color: #00ae93;
                    line-height: 44px;
                  }

                  .data {
                    font-size: 13px;
                    font-family: Roboto-Regular, Roboto;
                    font-weight: 400;
                    color: rgba(209, 212, 220, 0.7);
                    margin-top: 8px;

                    span {
                      font-size: 13px;
                      font-family: Roboto-Regular, Roboto;
                      font-weight: 400;
                      color: rgba(209, 212, 220, 0.7);
                    }
                  }
                }

                .goods-earnings-select {
                  margin-top: 8px;
                  display: flex;
                  justify-content: flex-end;

                  .el-select {
                    margin-left: 20px;

                    .el-input {
                      .el-input__inner {
                        height: 32px !important;
                        background: rgba(159, 159, 159, 0.1) !important;
                        border: 1px solid rgba(209, 212, 220, 0.5);
                        border-radius: 4px !important;
                        color: #d1d4dc;
                      }

                      .el-input__inner.is-focus {
                        color: #d1d4dc;
                      }

                      .el-select__caret {
                        line-height: 32px;
                      }
                    }
                  }
                }

                .goods-assets-bnt {
                  .earningChange {
                    .el-radio-button {
                      width: 69px;
                      height: 32px;
                      border-radius: 16px;
                      padding: 0 !important;
                      margin: 0 !important;

                      .el-radio-button__inner {
                        width: 69px;
                        height: 32px;
                        background: transparent;
                        font-size: 13px;
                        font-family: MicrosoftYaHei;
                        color: #d1d4dc;
                        line-height: 17px;
                        border: none;
                      }

                      .el-radio-button__inner:focus {
                        background: #33353e !important;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        background: #33353e;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        border-color: none;
                        -webkit-box-shadow: none;
                        box-shadow: none;
                      }
                    }
                  }
                }
              }

              .goods-assets-body {
                .goods-charts {
                  padding: 0 32px;
                }
              }
            }

            .more-than-empty {
              color: #d1d4dc !important;
              margin-top: 20px;
              width: 590px;
              height: 518px;
              background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;
              display: flex;
              flex-direction: column;

              .assets-header {
                display: flex;
                justify-content: center;
                margin-top: 20px;
                height: 118px !important;

                .assets-bnt {
                  .el-radio-group {
                    .el-radio-button {
                      width: 69px;
                      height: 32px;
                      border-radius: 16px;
                      padding: 0 !important;
                      margin: 0 !important;

                      .el-radio-button__inner {
                        width: 69px;
                        height: 32px;
                        background: transparent;
                        font-size: 13px;
                        font-family: MicrosoftYaHei;
                        color: #d1d4dc;
                        line-height: 17px;
                        border: none;
                      }

                      .el-radio-button__inner:focus {
                        background: #33353e !important;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        background: #33353e;
                        border-radius: 16px;
                        border: none;
                      }

                      .el-radio-button__orig-radio:checked+.el-radio-button__inner {
                        border-color: none;
                        -webkit-box-shadow: none;
                        box-shadow: none;
                      }
                    }
                  }
                }
              }

              .assets-body {
                height: 100%;

                .chart {
                  width: 100%;
                  height: 100% !important;
                }
              }

              .assets-body-list {
                .current-assets {
                  border-radius: 8px 8px 0 0;
                  border: none;

                  .el-table__header-wrapper {
                    display: block !important;

                    .el-table__header {
                      .has-gutter {
                        tr {
                          height: 48px !important;
                          background: transparent;

                          .el-table__cell {
                            padding: 0 !important;

                            .cell {
                              height: 48px !important;
                              line-height: 48px !important;
                            }
                          }

                          .gutter {
                            background: rgba(102, 102, 102, 0.1) !important;
                            border-bottom: none;
                          }
                        }
                      }
                    }
                  }

                  .el-table__body-wrapper {

                    //height: 336px !important;
                    .el-table__body tr:hover>td {
                      background: rgba(237, 189, 136, 1) !important;

                      .cell {
                        color: #33353e !important;
                        font-size: 14px;
                        font-family: Roboto-Regular, Roboto;
                        font-weight: 400;
                      }
                    }

                    .el-table__body {
                      tr {
                        height: 48px !important;

                        th {
                          .cell {
                            .caret-wrapper {
                              .sort-caret {
                                border-top-color: rgba(237,
                                    189,
                                    136,
                                    1) !important;
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }

            .exclusive-teach {
              color: #d1d4dc !important;
              margin-top: 25px;
              width: 800px;
              height: 492px;
              background: rgba(159, 159, 159, 0.1);
              border-radius: 8px;
              //opacity: 0.1;
            }
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .oddRow {
    //斑马纹样式

    color: white;

    background-color: rgba(102, 102, 102, 0.1) !important;

    .el-table__cell {
      padding: 0 !important;
      margin: 0 !important;

      .cell {
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #d1d4dc;
      }
    }
  }

  .evenRow {
    background-color: rgba(255, 255, 255, 0.1) !important;

    color: white;

    .el-table__cell {
      padding: 0 !important;
      margin: 0 !important;

      .cell {
        font-size: 14px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #d1d4dc;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/spotGoods/personalSpot.vue